import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListiniListComponent } from './listini-list/listini-list.component';
import {SharedModule} from "../shared/Shared.module";
import { ListinoImportComponent } from './listino-import/listino-import.component';
import {NgMultiSelectDropDownModule} from '../../LibrerieCustom/MultiselectDropdown'
import {NgbModalModule, NgbModule, NgbPaginationModule} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule, Routes} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import { ListinoEditComponent } from './listino-edit/listino-edit.component';
import {ProgettiModule} from "../Progetti/Progetti.module";
import { ListinoProdottiEditComponent } from './listino-prodotti-edit/listino-prodotti-edit.component';
import { ListinoProdottiAggiunteComponent } from './listino-prodotti-aggiunte/listino-prodotti-aggiunte.component';

const routes: Routes = [
  {
    path: 'listini',
    data: {
      title: "LISTA",
      urls: [{ title: "Lista"}],
    },
    component: ListiniListComponent,
  },
];

@NgModule({
  declarations: [
    ListiniListComponent,
    ListinoImportComponent,
    ListinoEditComponent,
    ListinoProdottiEditComponent,
    ListinoProdottiAggiunteComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgMultiSelectDropDownModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModalModule,
    RouterModule.forChild(routes),
    NgbPaginationModule,
    TranslateModule,
    ProgettiModule,
  ]
})
export class ListinoModule { }
